import { useState, useEffect, ReactNode } from 'react';

import parse from 'html-react-parser';
import { marked } from 'marked';

import { APIBaseChronos } from '@/api/hosts';
import { useGetReleaseNotes } from '@/api/queries/useGetReleaseNotes';
import { Breadcrumb } from '@/new/components/breadcrumb';
import { PageContainer } from '@/new/components/page-container';

export const ReleaseNotes = () => {
  const { data: releaseNotes, isLoading } = useGetReleaseNotes();
  const [parsedNotes, setParsedNotes] = useState<ReactNode>(null);

  useEffect(() => {
    const parseNotes = async () => {
      if (releaseNotes) {
        try {
          const renderer = new marked.Renderer();

          // Use crossorigin="anonymous" to stop CORS errors
          renderer.image = ({ href, title, text }) => {
            return `<img crossorigin="anonymous" src="${APIBaseChronos}/api/static/${href}" alt="${text}" title="${title || ''}" class="mx-6 my-10 mt-8 rounded-lg shadow-lg/2" />`;
          };

          const parsed: string = await marked.parse(releaseNotes, { renderer });
          setParsedNotes(parse(parsed));
        } catch (err) {
          console.error('Error parsing release notes:', err);
        }
      }
    };

    parseNotes();
  }, [releaseNotes]);

  return (
    <>
      <Breadcrumb items={[{ href: '/release-notes', label: 'Release Notes', active: true }]} />
      <PageContainer>
        <div className="mx-auto mb-16 w-full max-w-3xl">
          <div className="my-12">
            <h1 className="font-serif text-4xl font-medium">Release Notes</h1>
            <p className="my-3 text-sm text-gray-600">
              Stay updated with the latest features and improvements in Wexler.
            </p>
          </div>

          <div className="markdown-content">
            <div className="release-notes-markdown-content">
              {isLoading ? (
                <div className="flex items-center justify-center py-8">
                  <div className="text-gray-500">Loading release notes...</div>
                </div>
              ) : (
                parsedNotes
              )}
            </div>
          </div>
        </div>
      </PageContainer>
    </>
  );
};
